import React from "react";

import { Container } from "@mui/material";
import HeaderHelpPage from "../components/HeaderHelpPage";
import AuditLogsList from "../components/audit-logs";

const AuditLogs = () => {
  return (
    <Container>
      <HeaderHelpPage title="Audit Logs" description="Providing information about who has accessed the system and what operations he or she has performed during a given period of time." />
      <AuditLogsList />
    </Container>
  );
};

export default AuditLogs;
